import { render, staticRenderFns } from "./PhoneNumber.vue?vue&type=template&id=3fc9b7db&scoped=true&"
import script from "./PhoneNumber.vue?vue&type=script&lang=js&"
export * from "./PhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc9b7db",
  null
  
)

export default component.exports